import { object, string } from "yup";
import { defaultContextFields } from "../../shared.js";
const MAX = 32768;
const tooLong = "Too many characters entered.";
const isUnable = (canUnderstand, canRetain, canUseAndWeigh, canCommunicate) => canUnderstand === "unable" ||
    canRetain === "unable" ||
    canUseAndWeigh === "unable" ||
    canCommunicate === "unable";
export const fdmcaPart1DataSchema = object({
    ...defaultContextFields(),
    decisionOutline: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm the decision to be made"),
    materialTime: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please record the material time for this assessment"),
    supportSteps: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm your answer"),
    supportingPeople: string().trim().max(MAX, tooLong).default(""),
    additionalDecisionInformation: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please record the information relevant to the decision"),
    canUnderstandInformation: string()
        .oneOf(["able", "unable"])
        .required("Please confirm your answer"),
    reasoningUnderstand: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm reasoning"),
    canRetainInformation: string()
        .oneOf(["able", "unable"])
        .required("Please confirm your answer"),
    reasoningRetain: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm reasoning"),
    canUseAndWeighInformation: string()
        .oneOf(["able", "unable"])
        .required("Please confirm your answer"),
    reasoningUseAndWeigh: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm reasoning"),
    canCommunicateDecision: string()
        .oneOf(["able", "unable"])
        .required("Please confirm your answer"),
    reasoningCommunicate: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm reasoning"),
    impairmentDisturbance: string()
        .oneOf(["yes", "no", ""])
        .default("")
        .when([
        "canUnderstandInformation",
        "canRetainInformation",
        "canUseAndWeighInformation",
        "canCommunicateDecision",
    ], {
        is: isUnable,
        then: (s) => s
            .oneOf(["yes", "no"], "Please confirm your answer")
            .required("Please confirm your answer"),
        otherwise: (s) => s.notRequired(),
    }),
    impairmentType: string()
        .trim()
        .max(MAX, tooLong)
        .default("")
        .when("impairmentDisturbance", {
        is: "yes",
        then: (s) => s.required("Please confirm your answer"),
        otherwise: (s) => s.notRequired(),
    }),
    lackOfCapacity: string()
        .oneOf(["has-capacity", "lacks-capacity"])
        .required("Please confirm your answer"),
    reasoningLackOfCapacity: string()
        .trim()
        .max(MAX, tooLong)
        .required("Please confirm reasoning"),
});
export const exampleFdmcaData = [
    {
        data: {
            decisionOutline: "Whether to consent to elective surgery.",
            materialTime: "At the time of consenting to treatment during this admission.",
            supportSteps: "Provided easy-read leaflet and quiet environment.",
            supportingPeople: "Family carer present.",
            additionalDecisionInformation: "Information about the procedure, alternatives and likely consequences of deciding either way.",
            canUnderstandInformation: "unable",
            reasoningUnderstand: "Unable to recall the proposed procedure.",
            canRetainInformation: "able",
            reasoningRetain: "Recalled key information for over an hour.",
            canUseAndWeighInformation: "able",
            reasoningUseAndWeigh: "Weighed risks and benefits coherently.",
            canCommunicateDecision: "able",
            reasoningCommunicate: "Communicated decision verbally.",
            impairmentDisturbance: "yes",
            impairmentType: "Moderate vascular dementia.",
            lackOfCapacity: "lacks-capacity",
            reasoningLackOfCapacity: "Unable to understand the relevant information due to dementia.",
            user: {
                id: undefined,
                name: "Clinician",
                email: "clinician@example.com",
                address: "Clinic Address",
                postalCode: "AB1 2CD",
                isConfirmed: true,
                isSection12Approved: false,
                isGuest: false,
            },
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "AB1 2CD",
                dateOfBirth: "1950-01-01",
                nhsNumber: "1234567890",
            },
        },
    },
];
//# sourceMappingURL=fdmca.js.map